import type { ComputedRef } from 'vue'
import { computed } from 'vue'

import { useWorkflowInWorkviewStore } from '@/modules/Workview/useWorkflowInWorkviewStore'

export default (): {
  hasNoWorkflow: ComputedRef<boolean>
  hasLoadedWorkflowDetails: ComputedRef<boolean>
} => {
  const workflowInWorkviewStore = useWorkflowInWorkviewStore()

  const hasLoadedWorkflowDetails = computed(
    () => workflowInWorkviewStore.itemState?.workflow !== undefined,
  )

  const hasNoWorkflow = computed(
    () =>
      workflowInWorkviewStore.selectedStageInstance === null &&
      !workflowInWorkviewStore.itemState?.workflow,
  )

  return { hasNoWorkflow, hasLoadedWorkflowDetails }
}
